// extracted by mini-css-extract-plugin
export var backdrop = "styles-module--backdrop--5cdc9";
export var container = "styles-module--container--5b4ef";
export var content = "styles-module--content--537f3";
export var innerSidebar = "styles-module--innerSidebar--402e8";
export var opened = "styles-module--opened--113ff";
export var side = "styles-module--side--c6552";
export var sideToggle = "styles-module--sideToggle--b3497";